<template>
  <div>
    <div v-if="!loaded" v-html="info" style="text-align: left;" />
    <div v-else class="flex-row" :style="cmptStyle">
      <div class="card-body">
        <h4 class="card-title">
          {{ formData.title }}
        </h4>
        <h5 class="card-subtitle text-muted">
          {{ formData.intro }}
        </h5>
        <br />
        <img
          :src="formData.imgSrc"
          :alt="formData.title"
          style="width: 100%; max-width: 320px; height: auto; float: left; margin: 10px;">
          <!-- style="float: left; margin: 10px;"> -->
        <div class="card-text" style="margin: 10px;" v-html="json2Html(formData.body)"></div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import config from '@/config'
import { json2Html } from '@/service/utils/ProsemirrorConverter'
import * as htmlUtil from '@/service/utils/html'
import { cwcComponent } from '@/components/content/mixins'

export default {
  name: 'article',
  version: '0.0.2',
  mixins: [cwcComponent],
  props: {
    contentKey: {
      type: String,
      required: true
    },
    bgColor: {
      type: String,
      default: 'white'
    },
    // border: {
    //   type: Boolean,
    //   default: false
    // },
    genSeo: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      info: '... loading content!',
      /* Set to true if the content is loaded successfully, otherwise info is shown. */
      loaded: false,
      // cmptStyle: {
      //   backgroundColor: this.bgColor,
      //   border: this.border?'solid':'none',
      //   textAlign: 'left'
      // },
      formData: {}
    }
  }, // data
  async mounted () {
    console.log('TRACE-REMOVE: Article.mounted: this.genSeo is: ', this.genSeo)
    this.loaded = false
    try {
      const resp = await axios.get(config.glapiBaseUri + '/content/byContentKey/' +
        this.contentKey)
      const _contentData = resp.data.payload.content
      this.formData = _contentData.fragments
      if (this.genSeo && _contentData.jsonld) {
        htmlUtil.addJsonldToHead(_contentData.jsonld)
      }
      this.loaded = true
    } catch (e) {
      this.info = 'Error loading the content!'
      this.loaded = false
      console.error('ERROR: Exception is: ', e)
    }
  }, // mounted
  methods: {
    json2Html
  }
}
</script>

<style scoped>
@import '~bootstrap/dist/css/bootstrap.css';
</style>
